import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { DateInputImpl } from "./date-input-dialog.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  inputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};
const DateInputDialog = forwardRef(
  ({ children, ...restProps }, forwardedRef) => /* @__PURE__ */ jsx(DateInputImpl, { ...restProps, ref: forwardedRef, role: "dialog", children })
);
DateInputDialog.propTypes = propTypes;
export {
  DateInputDialog
};
